module.exports = __webpack_public_path__ + "img/help_safari1,2.55c7c426.png";